// Import 3rd-party dependencies
import { Component, Input } from '@angular/core';

// Import project-specific dependencies
import { TRENDING_LIST_ITEM_COMPONENT_CONSTS } from '@app/config/constants';

interface IListItemsMetaData {
  propertyLabel: string;
  propertyValue: string;
}

@Component({
  selector: 'app-trending-list-item',
  templateUrl: 'trending-list-item.component.html',
  styleUrls: ['./trending-list-item.component.css']
})
export class TrendingListItemComponent {
  @Input() title: string;
  @Input() url: string;
  @Input() lastUpdatedBy: string;
  @Input() rating: number;
  @Input() viewCount: number;
  @Input() summary: string;
  @Input() additionalInfo: IListItemsMetaData[];
  consts = TRENDING_LIST_ITEM_COMPONENT_CONSTS;

  openLink(url: string): void {
    window.open(url, '_blank');
  }
}
